



































































import { Component, Vue } from 'vue-property-decorator';

import Welcome from '@/components/RiskResources/Welcome.vue';
import IconTextLink from '@/components/RiskResources/IconTextLink.vue';
import Alert from '@/components/Global/Alert.vue';
import { Getter } from 'vuex-class';

import Auth from '@/services/Auth';

@Component({
	name: 'RiskManagementHome',
	components: {
		Welcome,
		IconTextLink,
		Alert,
	},
})
export default class RiskManagementHome extends Vue {
	@Getter('riskResourcesRequested', { namespace: 'Registration' })
	private riskResourcesRequested: boolean;
	private Auth: typeof Auth = Auth;

	constructor() {
		super();
	}
}
